export const RENTAL = {
  nickname: 'PRODUCTS.RENTAL.shortname',
  isHidden: true,
  icon:'rental'
};
